<template>
  <div class="flex w-full h-full bg-grey-100">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>
